<template>
  <div v-if="visible===1"
    :data-type="type" 
    class="tabs-content-component draggable"
  >
    <div class="tabs-content-component-icon">
      <i :class="icon"></i>
    </div>
    <div class="tabs-content-component-title">
      {{ title }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'Type',
  props: {
    visible: {
      type: Number,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },

  mounted() {
    $('.tabs-content-component').draggable({
      helper: 'clone',
      containment: '#xit-flow-builder'
    })
  },

  beforeDestroy() { // eslint-disable-line
    const tabContentComponentElement = $('.tabs-content-component')
    var isTabContentComponentDraggable = tabContentComponentElement.hasClass('ui-draggable')

    if (isTabContentComponentDraggable) {
      tabContentComponentElement.draggable('destroy')
    }
  },
}

</script>